import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addMessage } from "../utils/chatSlice";
import { getRandomName, getRandomString,getRandomEmoji } from "../utils/helper";
import ChatMessage from "./ChatMessage";

const LiveChat = () => {
  const [liveMessage, setLiveMessage] = useState("");
  const dispatch = useDispatch();

  const chatMessages = useSelector((store) => store.chat.messages);

  useEffect(() => {
    const i = setInterval(() => {
      // API Polling

      dispatch(
        addMessage({
          name: getRandomName(),
          message: getRandomString() + getRandomEmoji(),
        })
      );
    }, 3000);

    return () => clearInterval(i);
  }, []);

  return (
    <>
      <div className="w-full h-[600px] ml-2 p-2 border border-black bg-slate-100 rounded-lg overflow-y-scroll flex flex-col-reverse">
        <div>
          {
            // Disclaimer: Don't use indexes as keys
            chatMessages.map((c, i) => (
              <ChatMessage key={i} name={c.name} message={c.message} />
            ))
          }
        </div>
      </div>

      <form
        className="flex w-full p-2 ml-2 mt-2 border border-black rounded-lg" 
        onSubmit={(e) => {
          e.preventDefault();

          dispatch(
            addMessage({
              name: "Sahil",
              message: liveMessage,
            })
          );
          setLiveMessage("");
        }}
      >
        <input
          className="placeholder-white font-bold text-xl px-2 w-full border border-purple-700 bg-purple-300"
          type="text"
          placeholder="Type to chat"
          value={liveMessage}
          onChange={(e) => {
            setLiveMessage(e.target.value);
          }}
        />
        <button className="p-2 m-2 "> <img src="/send-icon.png"/></button>
      </form>
    </>
  );
};
export default LiveChat;
